@for (card of cards; track card) {
  <ion-card class="full-width" (click)="onCardSelectedEvent(card)"
    [ngClass]="{glow: card === selectedCard}">
    <ion-grid style="padding: 0;">
      <ion-row>
        <ion-col>
          <ion-grid>
            <ion-row>
              <ion-col col-8 style="text-align: left;">
                <span style="font-weight: bold;">{{ card.PaymentCardTypeEnumText }}</span>
                {{ 'CreditCard.EndingIn' | translate }}
                <span style="font-weight: bold;">{{ card.GhostedText | slice:-4 }}</span>
              </ion-col>
              <ion-col col-4 style="text-align: right;">
                <span>
                  {{ 'CreditCard.Exp' | translate }}:
                  {{ card.ExpirationMonth | number_slice }}/{{ card.ExpirationYear }}
                </span>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col col-8 style="text-align: left;">
                {{ card.CardHolderName }}
              </ion-col>
              <ion-col col-4 style="text-align: right;" [ngStyle]="{ 'color': !card.Cvn ? 'red' : 'black' }">
                <span>
                  {{ 'CreditCard.Cvn' | translate }}:&nbsp;
                  @if (!card.Cvn) {
                    <span>?</span>
                  }
                  @if (card.Cvn) {
                    <span>***</span>
                  }
                  <button class="remove-btn" (click)="archiveCard(card, $event)"> {{ 'General.Remove' | translate }}</button>
                </span>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
}